import AgreementType from 'components/blocks/Delta/Inputs/AgreementType';
import FieldsetContainer from 'components/blocks/Delta/Inputs/Containers/FieldsetContainer';
import Province from 'components/blocks/Delta/Inputs/Province';
import TestCommunity from 'components/blocks/Delta/Inputs/TestCommunity';
import AccordionForm from 'components/blocks/ManagementNewForms/Accordion/AccordionForm';
import FormDatosPersonales from 'components/blocks/ManagementNewForms/ButtonGroups/FormDatosPersonales';
import FormInputFecha from 'components/blocks/ManagementNewForms/Inputs/FormInputFecha';
import FormBotonSubmit from 'components/blocks/ManagementNewForms/Inputs/FormInputSubmit';
import FormInputText from 'components/blocks/ManagementNewForms/Inputs/FormInputTexto';
import FormObservaciones from 'components/blocks/ManagementNewForms/Inputs/FormObservaciones';
import React, { useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form';
import { get } from 'lodash';
import FormInputTable, { fillArray } from 'components/blocks/ManagementNewForms/Inputs/FormInputTable';
import Loader from 'components/blocks/Loader/Loader';
import useCreatetCertificadoEmpresaIt from 'services/record/CertificadoEmpresa/useCreateCertificadoEmpresaIt';
import useUpdateCertificadoEmpresaItByID from 'services/record/CertificadoEmpresa/useUpdateCertificadoEmpresaItByID';
import FormInputGrupoCotizacion from 'components/blocks/ManagementNewForms/Inputs/FormInputGrupoCotizacion';


const FormularioCertificadoEmpresa = ({ info, dataUser }: { info: boolean; dataUser: any }) => {


    const formMethods = useForm();
    const { register, handleSubmit, formState: { errors }, setValue, watch, reset } = formMethods;
    const { createCertificadoEmpresaIt, loadingCertificadoEmpresaIt, successCertificadoEmpresaIt, errorCertificadoEmpresaIt } = useCreatetCertificadoEmpresaIt();
    const { updateCertificadoEmpresaById, loadingUpdateCertificadoEmpresaById, successUpdateCertificadoEmpresaById, errorUpdateCertificadoEmpresaById } = useUpdateCertificadoEmpresaItByID();
    const [datosAPI, setDatosAPI] = useState(dataUser);
    const [bloquearEnvio, setBloquearEnvio] = useState<boolean>(false);
    const [loader, setLoader] = useState(false);

    const [baseCotizacionCertificado, setBaseCotizacionCertificado] = useState(dataUser?.TipoCertifizacion ?? 2);
    const [tiempoParcial, setTiempoParcial] = useState(dataUser?.TrabajadorContratoTiempoParcial ?? false);


    const watchProvincia = watch("DatosEmpresa.EmpresaProvincia");
    const watchProvinciaDesc = watch("DatosEmpresa.EmpresaProvinciaDescripcion");
    const watchComm = watch("DatosEmpresa.EmpresaComunidadCodigo");
    const watchCommDesc = watch("DatosEmpresa.EmpresaComunidadCodigoDescripcion");

    const watchWorkerContractCode = watch("DatosTrabajador.TrabajadorTipoContrato");

    //metodo para validar Arrays, pendiente de definicion
    const validarBasesCotizacionTiempoParcial = (value: any[]): true | string => {
        if (baseCotizacionCertificado !== 0 || tiempoParcial !== true) {
            return true;
        }

        if (!Array.isArray(value)) {
            return 'Formato de datos incorrecto';
        }

        for (let i = 0; i < value.length; i++) {
            const item = value[i];

            // Campos requeridos
            const requiredFields = [
                'BCAnno',
                'BCMes',
                'BCDias',
                'BCBaseContingenciaComun',
                'BCBaseContingenciaProfesional',
            ];

            for (const field of requiredFields) {
                if (
                    item[field] === undefined ||
                    item[field] === null ||
                    item[field] === ''
                ) {
                    return `Debes rellenar todos los campos del mes ${i + 1}`;
                }
            }
        }

        return true;
    };
    const validarBasesCotizacionExtincionLaboral = (value: any[]) => {
        if (baseCotizacionCertificado != 1) {
            return 'Estoy en el 1';
        }
    }

    const datosEjemploApi = {

        EmpresaNombre: "ACME Industrias S.L.",
        EmpresaCCC: "01234567890123456789",
        EmpresaProvincia: "28",
        EmpresaProvinciaDescripcion: "Madrid",
        EmpresaDomicilio: "Calle Falsa 123, 4ºB",
        EmpresaCodigoPostal: "28013",


        SolicitanteNombre: "María",
        SolicitanteApellido1: "López",
        SolicitanteApellido2: "García",
        SolicitanteIPF: "12345678A",
        SolicitanteIPFTipo: "1",
        SolicitanteTelefono: "600123456",
        SolicitanteFijo: "915123456",
        SolicitanteDomicilio: "Av. de América 45, 2ºA",
        SolicitanteCodigoPostal: "28002",
        SolicitanteProvincia: "28",
        SolicitanteProvinciaDescripcion: "Madrid",


        TrabajadorContratoTiempoParcial: true,
        TrabajadorSeguridadSocial: "789012345678",
        TrabajadorGrupoCotizacion: "3",
        TrabajadorFechaAltaEmpresa: "2024-02-15T00:00:00.000Z",
        TrabajadorFechaBajaEmpresa: null,
        TrabajadorFechaBajaMedica: null,
        TrabajadorFechaAbonoIT: null,
        CausaBajaMedica: "",
        TrabajadorCausaExticionPagoDirecto: "",
        TrabajadorFechaVacacionesDesde: "2025-07-01T00:00:00.000Z",
        TrabajadorFechaVacacionesHasta: "2025-07-15T00:00:00.000Z",
        TrabajadorVacacionesBase: "450.00",
        TrabajadorTipoContrato: "Temporal",
        TrabajadorTipoContratoDescripcion: "Contrato de obra y servicio",

    };




    //Estos Arrays vacios serán los que se pondrán en la tabla en el caso de que no se traiga información
    const emptyExtincion = {
        BCAnno: "",
        BCMes: "",
        BCDias: "",
        BCBaseContingenciaComun: ""
    };

    const emptyTiempoParcial = {
        BCAnno: "",
        BCMes: "",
        BCDias: "",
        BCBaseContingenciaComun: "",
        BCBaseContingenciaProfesional: "",
        BCHorasExtra: ""
    };

    // Función para rellenar hasta la longitud deseada

    const adaptApiResponseToDefaultValues = (data: any) => {
        //console.log(data)
        if (data) {

            reset({
                DatosPersonales: {
                    SolicitanteNombre: data?.TrabajadorNombre || "",
                    SolicitanteApellido1: data?.TrabajadorApellido1 || "",
                    SolicitanteApellido2: data?.TrabajadorApellido2 || "",
                    SolicitanteIPF: data?.TrabajadorIPF || "",
                    SolicitanteIPFTipo: data?.TrabajadorIPFTipo || 1,
                    SolicitanteDomicilio: data?.TrabajadorDomicilio || "",
                    SolicitanteCodigoPostal: data?.TrabajadorCodigoPostal || "",
                    SolicitanteProvincia: data?.TrabajadorProvincia || "",
                    SolicitanteComunidadCodigo: data?.TrabajadorLocalidad || "",
                },
                DatosTrabajador: {
                    CausaBajaMedica: data?.CausaBajaMedica,
                    TrabajadorCausaExticionPagoDirecto: data?.TrabajadorCausaExticionPagoDirecto,
                    TrabajadorContratoTiempoParcial: data?.TrabajadorContratoTiempoParcial.toString(),
                    TrabajadorFechaAbonoIT: data?.TrabajadorFechaAbonoIT,
                    TrabajadorFechaAltaEmpresa: data?.TrabajadorFechaAltaEmpresa,
                    TrabajadorFechaBajaEmpresa: data?.TrabajadorFechaBajaEmpresa,
                    TrabajadorFechaBajaMedica: data?.TrabajadorFechaBajaMedica,
                    TrabajadorFechaVacacionesDesde: data?.TrabajadorFechaVacacionesDesde,
                    TrabajadorFechaVacacionesHasta: data?.TrabajadorFechaVacacionesHasta,
                    TrabajadorGrupoCotizacion: data?.TrabajadorGrupoCotizacion,
                    TrabajadorSeguridadSocial: data?.TrabajadorSeguridadSocial,
                    TrabajadorTipoContrato: data?.TrabajadorTipoContrato,
                    TrabajadorTipoContratoDescripcion: data?.TrabajadorTipoContratoDescripcion,
                    TrabajadorVacacionesBase: data?.TrabajadorVacacionesBase
                },
                DatosEmpresa: {
                    EmpresaCCC: data?.EmpresaCCC,
                    EmpresaComunidadCodigo: data?.EmpresaComunidadCodigo,
                    EmpresaDomicilio: data?.EmpresaDomicilio,
                    EmpresaNombre: data?.EmpresaNombre,
                    EmpresaProvincia: data?.EmpresaProvincia,
                    EmpresaCodigoPostal: data?.EmpresaCodigoPostal
                },
                BaseCotizacion: {
                    TipoCertifizacion: data?.TipoCertificacion,
                    ExtincionLaboral: fillArray(data?.ExtincionLaboral, 6, emptyExtincion),
                    TrabajadorTiempoParcial: fillArray(data?.TrabajadorTiempoParcial, 3, emptyTiempoParcial),
                    MesAnteriorBajaMedica: {
                        BCMesAnteriorBaseContingenciaComun: data?.BCMesAnteriorBaseContingenciaComun,
                        BCMesAnteriorBaseContingenciaProfesional: data?.BCMesAnteriorBaseContingenciaProfesional,
                        BCMesAnteriorHorasExtra: data?.BCMesAnteriorHorasExtra
                    },
                    Agrario:{
                        SalarioReal: data?.SalarioReal,
                        CotizacionMesAnterior: data?.CotizacionMesAnterior,
                        TrabajandoDiaBaja: data?.TrabajandoDiaBaja,
                        AgrarioFijoEventual: data?.AgrarioFijoEventual
                    }


                }
            })
        }

    }

    useEffect(() => {
        adaptApiResponseToDefaultValues(dataUser);

        if (dataUser) {
            setBaseCotizacionCertificado(dataUser?.TipoCertifizacion ?? 2);
            setTiempoParcial(dataUser?.TrabajadorContratoTiempoParcial ?? false);
        }
    }, [dataUser]);




    const onSubmit = async (data: any) => {
        //console.log(data);
        setLoader(true);

        let prestacionId = dataUser?.PrestacionId || null;

        const datosEnvio = {
            Acepto: true,
            Id: dataUser.Id,
            PersonaId: dataUser.PersonaId,
            UsuarioId: dataUser.UsuarioId,
            CodigoExpediente: dataUser.CodigoExpediente,
            ExpedienteId: dataUser.ExpedienteId || null,
            PrestacionId: prestacionId,

            // Datos del trabajador
            TrabajadorContratoTiempoParcial: data?.DatosTrabajador?.TrabajadorContratoTiempoParcial ?? false,
            TrabajadorNombre: data?.DatosPersonales?.SolicitanteNombre ?? null,
            TrabajadorApellido1: data?.DatosPersonales?.SolicitanteApellido1 ?? null,
            TrabajadorApellido2: data?.DatosPersonales?.SolicitanteApellido2 ?? null,
            Movil: data?.DatosPersonales?.SolicitanteTelefono || null,
            TrabajadorIPF: data?.DatosPersonales?.SolicitanteIPF ?? null,
            TrabajadorIPFTipo: data?.DatosPersonales?.SolicitanteIPFTipo ?? null,
            TrabajadorProvincia: data?.DatosPersonales?.SolicitanteProvincia ?? null,
            TrabajadorProvinciaDescripcion: data?.DatosPersonales?.SolicitanteProvinciaDescripcion ?? null,
            TrabajadorLocalidad: data?.DatosPersonales?.SolicitanteComunidadCodigo ?? null,
            TrabajadorLocalidadDescripcion: data?.DatosPersonales?.SolicitanteComunidadCodigoDescripcion ?? null,
            TrabajadorDomicilio: data?.DatosPersonales?.SolicitanteDomicilio ?? null,
            TrabajadorCodigoPostal: data?.DatosPersonales?.SolicitanteCodigoPostal ?? null,
            TrabajadorSeguridadSocial: data?.DatosTrabajador?.TrabajadorSeguridadSocial ?? null,
            TrabajadorGrupoCotizacion: data?.DatosTrabajador?.TrabajadorGrupoCotizacion ?? null,
            TrabajadorFechaAltaEmpresa: data?.DatosTrabajador?.TrabajadorFechaAltaEmpresa ?? null,
            TrabajadorFechaBajaEmpresa: data?.DatosTrabajador?.TrabajadorFechaBajaEmpresa ?? null,
            TrabajadorFechaBajaMedica: data?.DatosTrabajador?.TrabajadorFechaBajaMedica ?? null,
            TrabajadorFechaAbonoIT: data?.DatosTrabajador?.TrabajadorFechaAbonoIT ?? null,
            CausaBajaMedica: parseInt(data?.DatosTrabajador?.CausaBajaMedica) ?? null,
            TrabajadorCausaExticionPagoDirecto: data?.DatosTrabajador?.TrabajadorCausaExticionPagoDirecto ?? null,
            TrabajadorFechaVacacionesDesde: data?.DatosTrabajador?.TrabajadorFechaVacacionesDesde ?? null,
            TrabajadorFechaVacacionesHasta: data?.DatosTrabajador?.TrabajadorFechaVacacionesHasta ?? null,
            TrabajadorVacacionesBase: data?.DatosTrabajador?.TrabajadorVacacionesBase ?? null,
            TrabajadorTipoContrato: data?.DatosTrabajador?.TrabajadorTipoContrato ?? null,
            TrabajadorTipoContratoDescripcion: data?.DatosTrabajador?.TrabajadorTipoContratoDescripcion ?? null,

            // Base de cotización
            TipoCertifizacion: parseInt(data?.BaseCotizacion?.TipoCertifizacion) ?? 0,
            AgrarioFijoEventual: data?.BaseCotizacion?.Agrario?.AgrarioFijoEventual ?? null,
            TrabajandoDiaBaja: data?.BaseCotizacion?.Agrario?.TrabajandoDiaBaja ?? false,
            CotizacionMesAnterior: data?.BaseCotizacion?.Agrario?.CotizacionMesAnterior || null,
            SalarioReal: data?.BaseCotizacion?.Agrario?.SalarioReal || null,
            BCMesAnteriorAnno: data?.BaseCotizacion?.MesAnteriorBajaMedica?.BCMesAnteriorAnno || null,
            BCMesAnteriorMes: data?.BaseCotizacion?.MesAnteriorBajaMedica?.BCMesAnteriorMes || null,
            BCMesAnteriorDias: data?.BaseCotizacion?.MesAnteriorBajaMedica?.BCMesAnteriorDias || null,
            BCMESAnteriorBaseContingenciaComun: parseFloat(data?.BaseCotizacion?.MesAnteriorBajaMedica?.BCMesAnteriorBaseContingenciaComun) || null,
            BCMESAnteriorBaseContingenciaProfesional: parseFloat(data?.BaseCotizacion?.MesAnteriorBajaMedica?.BCMesAnteriorBaseContingenciaProfesional) || null,
            BCMESAnteriorHorasExtra: parseFloat(data?.BaseCotizacion?.MesAnteriorBajaMedica?.BCMesAnteriorHorasExtra) || null,

            // Arrays
            TrabajadorTiempoParcial: data?.BaseCotizacion?.TrabajadorTiempoParcial ?? null,
            ExtincionLaboral: data?.BaseCotizacion?.ExtincionLaboral ?? null,

            // Datos empresa
            EmpresaNombre: data?.DatosEmpresa?.EmpresaNombre ?? null,
            EmpresaCCC: data?.DatosEmpresa?.EmpresaCCC ?? null,
            EmpresaProvincia: data?.DatosEmpresa?.EmpresaProvincia ?? null,
            EmpresaProvinciaDescripcion: data?.DatosEmpresa?.EmpresaProvinciaDescripcion ?? null,
            EmpresaDomicilio: data?.DatosEmpresa?.EmpresaDomicilio ?? null,
            EmpresaCodigoPostal: data?.DatosEmpresa?.EmpresaCodigoPostal ?? null
        };

        if (info) {
            await createCertificadoEmpresaIt(datosAPI.UsuarioId, datosAPI.ExpedienteId || null, datosEnvio);
            setBloquearEnvio(true);
        } else {
            await updateCertificadoEmpresaById(datosAPI.UsuarioId, prestacionId, datosAPI.Id, datosEnvio);
            setBloquearEnvio(true);
        }


        setTimeout(() => {
            setLoader(false);
        }, 500);
    };





    return (
        <FormProvider {...formMethods}>
            <div className="container form--simple-styled" id="formDeltawithoutleave">

                {/* ////////////// OBSERVACIONES DEL GESTOR A LA SOLICITUD ////////////// */}
                <FormObservaciones observaciones={datosAPI?.Observaciones} titulo={'Observaciones del Gestor a la Solicitud'} />

                <Loader activeLoader={loader || loadingCertificadoEmpresaIt || loadingUpdateCertificadoEmpresaById} label="Cargando Formulario"></Loader>








                {/* ////////////// COMIENZO FORMULARIO ////////////// */}
                {/* ////////////// DATOS DEL TRABAJADOR ////////////// */}
                <FormDatosPersonales />

                <AccordionForm title={'Datos de la Relación Laboral'} expandedInit={false} nombreError='DatosTrabajador' >
                    <div className="row mb-4">
                        <div className="col-xl-12">


                            <FieldsetContainer legend="" disabled={false}>

                                <div className={`col-xl-${4} col-md-${4} col-12`}>
                                    <div className="input-block">
                                        <label htmlFor="TrabajadorContratoTiempoParcial" className="input-block__label m-0">
                                            Contrato tiempo parcial
                                        </label>

                                        <select
                                            disabled={false}
                                            name="TrabajadorContratoTiempoParcial"
                                            id="TrabajadorContratoTiempoParcial"
                                            {...register("DatosTrabajador.TrabajadorContratoTiempoParcial", {
                                                setValueAs: value => value === 'true',
                                                onChange: (e) => setTiempoParcial(e.target.value === 'true')
                                            })}
                                            className="form-select"
                                        >
                                            <option value="false">No</option>
                                            <option value="true">Si</option>
                                        </select>

                                    </div>
                                </div>
                                <FormInputText
                                    name='DatosTrabajador.TrabajadorSeguridadSocial'
                                    id='DatosTrabajador.TrabajadorSeguridadSocial'
                                    label='Nº de Seguridad Social'
                                    md={4}
                                    xl={4}
                                    disabled={false}

                                />

                                <FormInputGrupoCotizacion
                                    name='DatosTrabajador.TrabajadorGrupoCotizacion'
                                    md={4}
                                    xl={4}
                                    col={12}


                                />
                                <div className="col-12 col-md-12" >
                                    <AgreementType
                                        errors={errors}
                                        register={register}
                                        setValue={setValue}
                                        disabled={false}
                                        watchWorkerContractCode={watchWorkerContractCode}
                                        idCode={'DatosTrabajador.TrabajadorTipoContrato'}
                                        idDescription={'DatosTrabajador.TrabajadorTipoContratoDescripcion'}
                                    />
                                </div>
                                <FormInputFecha
                                    name={'DatosTrabajador.TrabajadorFechaAltaEmpresa'}
                                    id={'DatosTrabajador.TrabajadorFechaAltaEmpresa'}
                                    label={'Fecha Alta Empresa'}
                                    placeholder={''}

                                    md={6}
                                    xl={6}
                                    col={12}
                                    maxDate={new Date(Date.now())}
                                    disableDate={false}
                                />
                                <FormInputFecha
                                    name={'DatosTrabajador.TrabajadorFechaBajaEmpresa'}
                                    id={'DatosTrabajador.TrabajadorFechaBajaEmpresa'}
                                    label={'Fecha Baja Empresa'}
                                    placeholder={''}
                                    md={6}
                                    xl={6}
                                    col={12}
                                    maxDate={new Date(Date.now())}
                                    disableDate={false}
                                />
                                <FormInputFecha
                                    name={'DatosTrabajador.TrabajadorFechaBajaMedica'}
                                    id={'DatosTrabajador.TrabajadorFechaBajaMedica'}
                                    label={'Fecha Baja Médica'}
                                    placeholder={''}
                                    md={6}
                                    xl={6}
                                    col={12}
                                    maxDate={new Date(Date.now())}
                                    disableDate={false}
                                />
                                <FormInputFecha
                                    name={'DatosTrabajador.TrabajadorFechaAbonoIT'}
                                    id={'DatosTrabajador.TrabajadorFechaAbonoIT'}
                                    label={'Fecha hasta la que se ha abonado la IT'}
                                    placeholder={''}
                                    md={6}
                                    xl={6}
                                    col={12}
                                    maxDate={new Date(Date.now())}
                                    disableDate={false}
                                />

                                {/* <FormInputText
                                    name='DatosTrabajador.CausaBajaMedica'
                                    id='DatosTrabajador.CausaBajaMedica'
                                    label='Causa baja médica'
                                    md={6}
                                    xl={6}
                                    disabled={true}
                                /> */}
                                <div className={`col-xl-${6} col-md-${6} col-12`}>
                                    <div className="input-block">
                                        <label htmlFor="CausaBajaMedica" className="input-block__label m-0">
                                            Causa de la Baja Médica
                                        </label>

                                        <select
                                            disabled={false}
                                            name="CausaBajaMedica"
                                            id="CausaBajaMedica"
                                            {...register("DatosTrabajador.CausaBajaMedica")}
                                            className="form-select"
                                        >
                                            <option value="0"> - - -</option>
                                            <option value="1">Enfermedad Comun</option>
                                            <option value="2">Enfermedad Profesional</option>
                                            <option value="3">Accidente No Laboral</option>
                                            <option value="4">Accidente Laboral</option>
                                        </select>

                                    </div>
                                </div>
                                <FormInputText
                                    name='DatosTrabajador.TrabajadorCausaExticionPagoDirecto'
                                    id='DatosTrabajador.TrabajadorCausaExticionPagoDirecto'
                                    label='Causa extinción/suspensión del pago directo'
                                    md={6}
                                    xl={6}
                                    disabled={false}
                                />
                                <label className='input-block__label mb-2 mt-4'>Días de vacaciones actuales retribuidas y no disfrutadas</label>
                                <FormInputFecha
                                    name={'DatosTrabajador.TrabajadorFechaVacacionesDesde'}
                                    id={'DatosTrabajador.TrabajadorFechaVacacionesDesde'}
                                    label={'Desde:'}
                                    placeholder={''}
                                    md={4}
                                    xl={4}
                                    col={12}
                                    maxDate={new Date(Date.now())}
                                    disableDate={false}
                                />
                                <FormInputFecha
                                    name={'DatosTrabajador.TrabajadorFechaVacacionesHasta'}
                                    id={'DatosTrabajador.TrabajadorFechaVacacionesHasta'}
                                    label={'Hasta:'}
                                    placeholder={''}
                                    md={4}
                                    xl={4}
                                    col={12}
                                    disableDate={false}

                                />
                                <FormInputText
                                    name='DatosTrabajador.TrabajadorVacacionesBase'
                                    id='DatosTrabajador.TrabajadorVacacionesBase'
                                    label='Base: '
                                    md={4}
                                    xl={4}
                                    disabled={false}
                                    pattern={/^[0-9]+([.,][0-9]+)?$/}
                                    patternMessage='Introduce un número válido (entero o decimal, con . o ,'
                                />

                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>







                {/* ////////////// DATOS DE LA EMPRESA ////////////// */}
                <AccordionForm title={'Datos de la Empresa'} expandedInit={false} nombreError='DatosEmpresa' >
                    <div className="row mb-4">
                        <div className="col-xl-12">
                            <FieldsetContainer legend="Datos de la Empresa" disabled={false}>
                                <FormInputText
                                    name='DatosEmpresa.EmpresaNombre'
                                    id='DatosEmpresa.EmpresaNombre'
                                    label='Nombre o Razon Social'
                                    md={6}
                                    xl={6}
                                    disabled={false}
                                />
                                <FormInputText
                                    name='DatosEmpresa.EmpresaCCC'
                                    id='DatosEmpresa.EmpresaCCC'
                                    label='Código Cuenta Cotización'
                                    md={6}
                                    xl={6}
                                    disabled={false}
                                    pattern={/^[0-9]{1,12}$/}
                                    patternMessage='Solo se permiten numeros'
                                />
                                <div className="col-xl-6 col-md-6">
                                    <Province
                                        errors={errors}
                                        register={register}
                                        idCode={'DatosEmpresa.EmpresaProvincia'}
                                        watchProvinceDescription={watchProvinciaDesc}
                                        idDescription={'DatosEmpresa.EmpresaProvinciaDescripcion'}
                                        watchProvinceCode={watchProvincia}
                                        setValue={setValue}
                                    />
                                </div>
                                <div className="col-xl-6 col-md-6">
                                    <TestCommunity
                                        errors={errors}
                                        register={register}
                                        setValue={setValue}
                                        watchProvinceCode={watchProvincia}
                                        watchCommunityCode={watchComm}
                                        watchCommunityDescription={watchCommDesc}
                                        idCode={'DatosPersonales.EmpresaComunidadCodigo'}
                                        idDescription={'DatosPersonales.EmpresaComunidadCodigoDescripcion'}
                                        filterByProvince={true}
                                    />
                                </div>
                                <FormInputText
                                    name='DatosEmpresa.EmpresaDomicilio'
                                    id='DatosEmpresa.EmpresaDomicilio'
                                    label='Domicilio (calle/plaza/...)'
                                    md={6}
                                    xl={6}
                                    disabled={false}
                                />
                                <FormInputText
                                    name='DatosEmpresa.EmpresaCodigoPostal'
                                    id='DatosEmpresa.EmpresaCodigoPostal'
                                    label='Código Postal'
                                    md={6}
                                    xl={6}
                                    disabled={false}

                                />

                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>





                {/* ////////////// BASES DE COTIAZACION A CERTIFICAR SEGUN EL SUPUESTO DE PAGO DIRECTO ////////////// */}
                <AccordionForm title={'Bases de cotización a certificar según el supuesto de pago directo'} expandedInit={false} nombreError='BaseCotizacion' >


                    <div className={`col-xl-${12} col-md-${12} col-12 mt-4`}>
                        <div className="input-block">
                            <label htmlFor="AgrarioFijoEventual" className="input-block__label m-0">
                                Base de cotización a certificar
                            </label>

                            <select
                                name="TipoCertifizacion"
                                id="TipoCertifizacion"
                                {...register("BaseCotizacion.TipoCertifizacion", {
                                    onChange: (e) => setBaseCotizacionCertificado(Number(e.target.value))
                                })}
                                className="form-select"
                            >
                                <option value={0}>Si no se ha extinguido la relación laboral o la baja médica es por accidente de trabajo/ enfermedad profesional o solicita la prestación de Riesgo</option>
                                <option value={1}>Si el pago directo es por extinción de la relación laboral y la baja médica derivada de enfermedad común o accidente no laboral</option>
                                <option value={2}>Régimen Especial Agrario</option>

                            </select>
                        </div>
                    </div>




                    <div className="row mb-4 col-12" style={{ display: baseCotizacionCertificado === 0 ? 'block' : 'none' }}>
                        <div className="col-xl-12">
                            <div >
                                <FieldsetContainer legend=" Si no se ha extinguido la relación laboral o la baja médica es por accidente de trabajo/ enfermedad profesional o solicita la prestación de Riesgo" disabled={false}>
                                    <label className='input-block__label mb-2 mt-4 fs-4'>Certificado de cotización del mes
                                        anterior a la baja médica</label>


                                    <FormInputText
                                        name='BaseCotizacion.MesAnteriorBajaMedica.BCMesAnteriorAnno'
                                        id='BaseCotizacion.MesAnteriorBajaMedica.BCMesAnteriorAnno'
                                        label='Año: '
                                        md={4}
                                        xl={4}
                                        disabled={false}
                                        pattern={/^[0-9]$/}
                                        patternMessage='Solo se permiten numeros'
                                    />
                                    <FormInputText
                                        name='BaseCotizacion.MesAnteriorBajaMedica.BCMesAnteriorMes'
                                        id='BaseCotizacion.MesAnteriorBajaMedica.BCMesAnteriorMes'
                                        label='Mes: '
                                        md={4}
                                        xl={4}
                                        disabled={false}
                                        pattern={/^[0-9]$/}
                                        patternMessage='Solo se permiten numeros'
                                    />
                                    <FormInputText
                                        name='BaseCotizacion.MesAnteriorBajaMedica.BCMesAnteriorDias'
                                        id='BaseCotizacion.MesAnteriorBajaMedica.BCMesAnteriorDias'
                                        label='Días: '
                                        md={4}
                                        xl={4}
                                        disabled={false}
                                        pattern={/^[0-9]+$/}
                                        patternMessage='Solo se permiten numeros'
                                    />
                                    <FormInputText
                                        name='BaseCotizacion.MesAnteriorBajaMedica.BCMesAnteriorBaseContingenciaComun'
                                        id='BaseCotizacion.MesAnteriorBajaMedica.BCMesAnteriorBaseContingenciaComun'
                                        label='Base contingencias comunes'
                                        md={4}
                                        xl={4}
                                        disabled={false}
                                        pattern={/^[0-9]+([.,][0-9]+)?$/}
                                        patternMessage='Introduce un número válido (entero o decimal, con . o ,'
                                    />
                                    <FormInputText
                                        name='BaseCotizacion.MesAnteriorBajaMedica.BCMesAnteriorBaseContingenciaProfesional'
                                        id='BaseCotizacion.MesAnteriorBajaMedica.BCMesAnteriorBaseContingenciaProfesional'
                                        label='Base contingencias profesionales'
                                        md={4}
                                        xl={4}
                                        disabled={false}
                                        pattern={/^[0-9]+([.,][0-9]+)?$/}
                                        patternMessage='Introduce un número válido (entero o decimal, con . o ,'
                                    />
                                    <FormInputText
                                        name='BaseCotizacion.MesAnteriorBajaMedica.BCMesAnteriorHorasExtra'
                                        id='BaseCotizacion.MesAnteriorBajaMedica.BCMesAnteriorHorasExtra'
                                        label='Horas extra y otros conceptos'
                                        md={4}
                                        xl={4}
                                        disabled={false}
                                        pattern={/^[0-9]+([.,][0-9]+)?$/}
                                        patternMessage='Introduce un número válido (entero o decimal, con . o ,'
                                    />

                                    <div style={{ display: tiempoParcial ? 'block' : 'none' }}>
                                        <label data-input-name={'BaseCotizacion.TrabajadorTiempoParcial'} className='input-block__label mb-2 mt-1 fs-4'>Trabajador/a con jornada a tiempo
                                            parcial: certificado de las bases
                                            de cotización de los tres meses
                                            anteriores a la baja médica
                                        </label>

                                        <FormInputTable
                                            name="BaseCotizacion.TrabajadorTiempoParcial"
                                            heads={["Año", "Mes", "Días", "Base contingencias comunes", "Base contingencias profesionales", "Horas extra y otros conceptos"]}
                                            nameHeads={["BCAnno", "BCMes", "BCDias", "BCBaseContingenciaComun", "BCBaseContingenciaProfesional", "BCHorasExtra"]}
                                            removeButton={false}
                                            addButton={false}
                                            widthColumn={[1, 1, 1, 1, 1, 1]}
                                            validateFunction={undefined}
                                            inputType={[2, 2, 2, 3, 3, 3]}

                                        />
                                    </div>





                                </FieldsetContainer>
                            </div>

                        </div>
                    </div>
                    <div className="row mb-4 col-12" style={{ display: baseCotizacionCertificado === 1 ? 'block' : 'none' }}>
                        <div className="col-xl-12">
                            <div >
                                <FieldsetContainer legend="Si el pago directo es por extinción de la relación laboral y la baja médica derivada de enfermedad común o accidente no laboral" disabled={false}>
                                    <label className='input-block__label mb-2 mt-5 fs-4'>Certicado de cotizaciones de los
                                        180 últimos días cotizados
                                    </label>
                                    <FormInputTable
                                        name="BaseCotizacion.ExtincionLaboral"
                                        heads={["Año", "Mes", "Días", "Base contingencias comunes"]}
                                        nameHeads={["BCAnno", "BCMes", "BCDias", "BCBaseContingenciaComun"]}
                                        removeButton={false}
                                        addButton={false}
                                        widthColumn={[1, 1, 1, 2]}
                                        validateFunction={undefined}
                                        inputType={[2, 2, 2, 3]}
                                        arrayModal={[null, "Solo se admiten números enteros", null, ""]}
                                    />




                                </FieldsetContainer>
                            </div>
                        </div>
                    </div>




                    <div className="row mb-4 col-12" style={{ display: baseCotizacionCertificado === 2 ? 'block' : 'none' }}>
                        <div className="col-xl-12">
                            <div >
                                <FieldsetContainer legend="Régimen Especial Agrario" disabled={false}>
                                    <div className={`col-xl-${6} col-md-${6} col-12`}>
                                        <div className="input-block">
                                            <label htmlFor="AgrarioFijoEventual" className="input-block__label m-0">
                                                Tipo de Gestión de Actividad
                                            </label>

                                            <select
                                                name="AgrarioFijoEventual"
                                                id="AgrarioFijoEventual"
                                                {...register("BaseCotizacion.Agrario.AgrarioFijoEventual")}
                                                className="form-select"
                                            >
                                                <option value={0}>Fijo</option>
                                                <option value={1}>Eventual</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className={`col-xl-${6} col-md-${6} col-12`}>
                                        <div className="input-block">
                                            <label htmlFor="TrabajandoDiaBaja" className="input-block__label m-0">
                                                ¿Estaba trabajando
                                                el día de la baja?
                                            </label>
                                            <select
                                                name="TrabajandoDiaBaja"
                                                id="TrabajandoDiaBaja"
                                                {...register("BaseCotizacion.Agrario.TrabajandoDiaBaja", {
                                                    setValueAs: value => value === 'true'
                                                })}
                                                className="form-select"
                                            >
                                                <option value="false">No</option>
                                                <option value="true">Si</option>
                                            </select>
                                        </div>
                                    </div>

                                    <FormInputText
                                        name={`BaseCotizacion.Agrario.CotizacionMesAnterior`}
                                        id={`BaseCotizacion.Agrario.CotizacionMesAnterior`}
                                        label='Cotización jornadas reales mes anterior baja'
                                        md={6}
                                        xl={6}
                                        pattern={/^[0-9]+$/}
                                        patternMessage='Solo se permiten números'
                                    />
                                    <FormInputText
                                        name={`BaseCotizacion.Agrario.SalarioReal`}
                                        id={`BaseCotizacion.Agrario.SalarioReal`}
                                        label='Salario Real'
                                        md={6}
                                        xl={6}
                                        pattern={/^\d+(?:[.,]\d+)?$/}
                                        patternMessage='Solo se permiten valores numericos y decimales'
                                    />

                                </FieldsetContainer>
                            </div>
                        </div>
                    </div>


                </AccordionForm>





                {/* ////////////// FINAL FORMULARIO ////////////// */}


                {/* ////////////// BLOQUEO DEL ENVIO DEL FORMULARIO //////////// */}
                <FormBotonSubmit
                    disableSubmit={bloquearEnvio}
                    onSubmit={handleSubmit(onSubmit)}
                    successCreate={successCertificadoEmpresaIt}
                    successUpdate={successUpdateCertificadoEmpresaById}
                    errorCreate={errorCertificadoEmpresaIt}
                    errorUpdate={errorUpdateCertificadoEmpresaById}
                    datosAPI={datosAPI}
                    info={info}
                />


                <p style={{ fontSize: '12px' }} className=' paragraph  text-secondary  mb-4'>
                    Esta solicitud va a ser tramitada por medios informáticos. Los datos personales que figuran en ella serán incorporados a un fichero de base de datos para el cálculo y control de la prestación económica
                    que se le reconozca, y permanecerán bajo custodia de esta Entidad. En cualquier momento puede ejercitar su derecho de acceso, rectificación, cancelación y oposición sobre los datos incorporados al
                    fichero ( art. 5 de la ley 15/1999 de 13 diciembre de Protección de datos de carácter personal, BOE del día 14)
                </p>

                <p style={{ fontSize: '12px' }} className=' paragraph  text-secondary  mb-4'>
                    En cumplimiento de lo establecido en la normativa sobre de Protección de Datos de Carácter Personal, Solimat Mutua Colaboradora con la Seguridad Social nº 72 le informa que sus datos de carácter
                    personal serán objeto de tratamiento, con la finalidad del mantenimiento y cumplimiento de la relación. La base jurídica que legitima el tratamiento de sus datos es el
                    cumplimiento de una obligación legal. Sus datos serán conservados de forma indefinida en nuestra entidad para atender a las posibles responsabilidades derivadas del tratamiento. Usted
                    podrá revocar el consentimiento prestado, así como ejercitar sus derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento, o portabilidad, en su caso, remitiendo un
                    escrito a la siguiente dirección: Solimat, Mutua Colaboradora con la Seguridad Social nº 72, C/ Berna, 1, 45003, Toledo, adjuntando su NIF. Si considera que sus derechos no han sido
                    debidamente atendidos, puede contactar con nuestro delegado de protección de datos lopd@solimat.com o interponer una reclamación frente a la Agencia Española de Protección de Datos.
                </p>



            </div>
        </FormProvider>
    )
}

export default FormularioCertificadoEmpresa
